import React from "react";
import { Button } from "../../components/ui/Button";

interface ThemedButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  themeColor: string;
}

const ThemedButton: React.FC<ThemedButtonProps> = ({ themeColor, children, ...props }) => {
  return (
    <Button
      {...props}
      style={{
        color: themeColor,
        borderColor: themeColor,
        backgroundColor: "white",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = themeColor;
        e.currentTarget.style.color = "#fff";
        e.currentTarget.style.borderColor = themeColor;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "white";
        e.currentTarget.style.color = themeColor;
        e.currentTarget.style.borderColor = themeColor;
      }}
    >
      {children}
    </Button>
  );
};

export default ThemedButton;
